module.exports = __webpack_public_path__ + "assets/img/HotTicket_bg.8286917f.png";